import React, { useEffect, useState, useRef, useContext } from 'react';
import Masonry from 'masonry-layout';
import { Icon } from '@iconify/react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AppSettings, externalAddress } from '../../config/app-settings.js';
import { Card, CardBody } from '../../components/card/card.jsx';

function Captacao() {
	const aiContainerRef = useRef(null);
  const aiGeneratingRef = useRef(null);
  const aiGeneratedRef = useRef(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [isGenerated, setIsGenerated] = useState(false);
  const [dropdownRatioValue, setDropdownRatioValue] = useState("Ratio");
  const [dropdownStyleValue, setDropdownStyleValue] = useState("Style");

  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const context = useContext(AppSettings);
  const location = useLocation();
  const navigate = useNavigate();

    
  /*
	useEffect(() => {
		setTimeout(function() {
			new Masonry('[data-masonry]');
		}, 50);
    // eslint-disable-next-line
  }, []);
  */

  	useEffect(() => {
			context.setAppHeaderNone(true);
			context.setAppSidebarNone(true);
			context.setAppContentFullHeight(false);
			//context.setAppContentClass('p-0');
  
		}, []);

	function enviar() {

			if (nome == '' || email == '' || telefone == '') {
				setError(true);
				return;
			}

			setLoading(true);

			const query = new URLSearchParams(location.search);
			const campaign = query.get('utm_campaign');
			const content = query.get('utm_content');
	
			fetch(externalAddress+'/api/lead/novo', {
				method: 'POST',
				body: JSON.stringify({"nome": nome, "email": email, "telefone": telefone, "origem": 'biblioteca_setups_lancamento', 
					"campaign": campaign, "content": content, "lista": 51}),
				headers: {
				'Content-Type': 'application/json',
			}})
			.then((result) => { 
				setLoading(false);
				navigate('/confirmacao');
			});
	
		}
	
	return (
		<>
			<div className="card border-0 overflow-hidden position-relative mb-5 mt-2">
				<div className="position-relative p-3 p-lg-4 bg-white bg-opacity-10">
					<span className="bg-white bg-opacity-15 position-absolute top-0 start-0 m-lg-4 m-3 px-3 py-1 fw-semibold small d-flex align-items-center">
						<div className="d-inline-flex align-items-center">
							<i className="fa fa-circle fa-fw fs-4px text-theme text-opacity-75 me-3px ms-n1"></i> 
							<i className="fa fa-circle fa-fw fs-4px text-theme text-opacity-50 me-3px"></i>
							<i className="fa fa-circle fa-fw fs-4px text-theme text-opacity-25 me-2"></i>
						</div>
						Data n' Quant
					</span>
					
					<div className="text-center text-body fs-1 fw-semibold mt-5 pt-5">
						
						Pare de improvisar: chegou a sua biblioteca de estratégias automatizadas
					</div>
					
					<div className="text-center text-body text-opacity-75 mb-4 fs-5">Participe do evento e descubra como acessar um acervo inédito de setups.</div>
					
					<div className="position-relative mx-auto h-100 w-100 mb-3" style={{ maxWidth: '520px'}}>
						{error ?
						<div className="alert alert-danger">Todos os campos são obrigatórios</div>
						: ''}
						<input type="text" onChange={(e) => setNome(e.target.value)} className="form-control form-control-lg bg-black bg-opacity-25 border-2 border-white border-opacity-25 shadow-none h-55px mb-3" id="nome" placeholder="Nome" />
						<input type="text" onChange={(e) => setEmail(e.target.value)} className="form-control form-control-lg bg-black bg-opacity-25 border-2 border-white border-opacity-25 shadow-none h-55px mb-3" id="email" placeholder="Email" />
						<input type="text" onChange={(e) => setTelefone(e.target.value)} className="form-control form-control-lg bg-black bg-opacity-25 border-2 border-white border-opacity-25 shadow-none h-55px mb-3" id="telefone" placeholder="Telefone" />
					</div>
					
					<div className="position-relative h-100 w-100 mb-5 pb-3 mx-auto d-flex" style={{ maxWidth: '520px'}}>
						<div className="dropdown me-3">
							
						</div>
						<div className="dropdown me-3 ms-auto">
							
						</div>
						{loading ?
							<div className="">Processando...</div>
							:
							<button type="button" onClick={enviar} className="btn bg-white bg-opacity-25"> <span id="aiStyleText">Enviar</span> <i className="fa fa-chevron-right fa-fw opacity-50 ms-1"></i></button>
						}
					</div>

					<div className="text-center text-body fs-1 fw-semibold">
						Biblioteca de Setups
					</div>
					
					<div className="text-center text-body text-opacity-75 mb-5 fs-5">Um Novo Capítulo no Trading Automatizado</div>
					
					<div className="row g-3 g-lg-4">
						<div className="col-sm-6 col-xl-3">
							<div className="card border-0 overflow-hidden">
								<img className="card-img object-fit-cover" height="180" src="/assets/img/ai/lib_setups.png" alt="" />
								<div className="card-img-overlay h-100 d-flex align-items-end bg-gradient-to-t bg-gradient-from-black bg-gradient-to-transparent">
									<div>
										<div className="fw-bold">Centenas de Setups</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-sm-6 col-xl-3">
							<div className="card border-0 overflow-hidden">
								<img className="card-img object-fit-cover" height="180" src="/assets/img/ai/lib_estrategias.png" alt="" />
								<div className="card-img-overlay h-100 d-flex align-items-end bg-gradient-to-t bg-gradient-from-black bg-gradient-to-transparent">
									<div>
										<div className="fw-bold">Dezenas de Estratégias</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-sm-6 col-xl-3">
							<div className="card border-0 overflow-hidden">
								<img className="card-img object-fit-cover" height="180" src="/assets/img/ai/lib_ativos.png" alt="" />
								<div className="card-img-overlay h-100 d-flex align-items-end bg-gradient-to-t bg-gradient-from-black bg-gradient-to-transparent">
									<div>
										<div className="fw-bold">Mais de 30 Ativos</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-sm-6 col-xl-3">
							<div className="card border-0 overflow-hidden">
								<img className="card-img object-fit-cover" height="180" src="/assets/img/ai/lib_mercados.png" alt="" />
								<div className="card-img-overlay h-100 d-flex align-items-end bg-gradient-to-t bg-gradient-from-black bg-gradient-to-transparent">
									<div>
										<div className="fw-bold">Diversos Mercados</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>


			<div className="container">
				<div className="row justify-content-center">
					<div className="col-xl-12">
						<div className="row">
							<div className="col-xl-12">
								
								<Card>
									<CardBody className="p-0">
										<div className="row gx-0">
											<div className="col-xl-12 position-relative">
												<div className="p-4 p-lg-5">
													<div className="display-5 text-white mb-3">Um evento online, gratuito e inédito para quem quer parar de improvisar e começar a operar com robôs.</div>
													<div className="mb-4 font-monospace lh-lg" style={{fontSize: '14px'}}>
														❌ Chega de começar do zero.<br/>
														❌ Chega de depender de promessas milagrosas de rentabilidade.<br/>
														❌ Chega de seguir setups que você não entende.<br/>
														❌ Chega de ficar travado na hora de testar novas ideias.<br/>
														❌ Chega de gastar horas no gráfico pra sair no prejuízo.<br/>
													</div>
													<div className="mb-4 font-monospace lh-lg" style={{fontSize: '14px'}}>
														Está no ar um novo capítulo no design de estratégias automatizadas:<br/>
														📚 A Biblioteca de Setups do BotSpot.
													</div>
													
												</div>
											</div>
											
										</div>
									</CardBody>
								</Card>
								<hr></hr>
								<Card>
									<CardBody className="p-0">
										<div className="row gx-0">
											<div className="col-xl-12 position-relative">
												<div className="p-4 p-lg-5">
													<div className="display-5 text-white mb-3">O que você vai encontrar nesse evento:</div>
													<div className="mb-4 font-monospace lh-lg" style={{fontSize: '14px'}}>
														✔️ Uma curadoria real de ideias promissoras, extraídas por data mining, organizadas de forma estratégica.<br/>

														✔️ Setups brutos prontos para teste e automação – você só precisa explorar, testar e colocar pra rodar.<br/>

														✔️ O guia para montar seu portfólio sistemático, mesmo que você não tenha ideias ou tempo para ficar criando tudo do zero.<br/>

														✔️ Um acervo inteligente de estratégias no-code, revelando sinais que antes estavam escondidos sob milhares de linhas de dados.
													</div>
													
													
												</div>
											</div>
											
										</div>
									</CardBody>
								</Card>

								<hr></hr>
								<Card>
									<CardBody className="p-0">
										<div className="row gx-0">
											<div className="col-xl-12 position-relative">
												<div className="p-4 p-lg-5">
													<div className="display-5 text-white mb-3">Para quem é este evento?</div>
													<div className="mb-4 font-monospace lh-lg" style={{fontSize: '14px'}}>
														✅ Para quem quer operar com robôs e tem dificuldade em criar estratégias lucrativas<br/>

														✅ Para quem já opera com robôs e quer novas ideias de estratégias<br/>

														✅ Para quem quer automatizar sem precisar programar e depender de terceiros<br/>

														✅ Para quem busca fontes de renda automatizadas com lógica e método<br/>

														✅ Para quem cansou do chute e quer atuar como um verdadeiro estrategista
													</div>
													
													
												</div>
											</div>
											
										</div>
									</CardBody>
								</Card>

								<hr></hr>
								<Card>
									<CardBody className="p-0">
										<div className="row gx-0">
											<div className="col-xl-12 position-relative">
												<div className="p-4 p-lg-5">
													<div className="display-5 text-white mb-3">Por que participar?</div>
													<div className="mb-4 font-monospace lh-lg" style={{fontSize: '14px'}}>
														Este evento não é uma mentoria.<br/>
														Não é uma fórmula mágica.<br/><br/>

														🎯 É um relatório tático completo.<br/>
														🗺️ É um mapa de exploração para quem busca consistência.<br/>
														📂 É um dossiê vivo de estratégias prontas para automatizar.
													</div>
													
													
												</div>
											</div>
											
										</div>
									</CardBody>
								</Card>

								<hr></hr>
								<Card>
									<CardBody className="p-0">
										<div className="row gx-0">
											<div className="col-xl-12 position-relative">
												<div className="p-4 p-lg-5">
													<div className="display-5 text-white mb-3">Prepare-se para desbloquear o maior acervo de setups sistemáticos que você já viu.</div>
													<div className="mb-4 font-monospace lh-lg" style={{fontSize: '14px'}}>
														📅 3 dias de conteúdo: 23, 24 e 25 de Junho.<br/>
														🔓 Acesso gratuito<br/>
														🎁 Surpresas e bônus para os inscritos
													</div>
													
													
												</div>
											</div>
											
										</div>
									</CardBody>
								</Card>

								

							</div>

							<div className="col-xl-4 col-md-6 py-3 py-xl-5">
								<Card className="h-100">
									<CardBody className="p-4 p-lg-5 d-flex flex-column">
										<div className="d-flex align-items-center">
											<div className="flex-1">
												<div className="h6 font-monospace mb-3">Dia 1 – A Crise da Criação de Estratégias</div>
											</div>
										</div>
										<hr className="my-4" />
										<div className="mb-5 text-body text-opacity-50 flex-1">
											<div className="mb-4 font-monospace lh-lg" style={{fontSize: '14px'}}>
												Você vai entender por que 90% dos traders travam quando precisam criar setups automatizados – e como a nova Biblioteca de Setups resolve esse gargalo de forma inédita.<br/><br/>

												🔎 Insights sobre data mining, design de estratégia e erros comuns que destroem uma boa ideia antes mesmo dela nascer.
											</div>
										</div>
										
									</CardBody>
								</Card>
							</div>
							<div className="col-xl-4 col-md-6 py-3 py-xl-5">
								<Card className="h-100">
									<CardBody className="p-4 p-lg-5 d-flex flex-column">
										<div className="d-flex align-items-center">
											<div className="flex-1">
												<div className="h6 font-monospace mb-3">Dia 2 – Por Dentro da Biblioteca</div>
											</div>
										</div>
										<hr className="my-4" />
										<div className="mb-5 text-body text-opacity-50 flex-1">
											<div className="mb-4 font-monospace lh-lg" style={{fontSize: '14px'}}>
												Vamos abrir a caixa preta.<br/>
												Você vai ver como foi feita a mineração dos setups e como esse acervo pode ser um ponto de partida poderoso para seus testes e automações com o SDK.<br/><br/>

												📚 É aqui que o evento vira uma chave na sua cabeça: você não precisa mais inventar do zero.
											</div>
										</div>
										
									</CardBody>
								</Card>
							</div>
							<div className="col-xl-4 col-md-6 py-3 py-xl-5">
								<Card className="h-100">
									<CardBody className="p-4 p-lg-5 d-flex flex-column">
										<div className="d-flex align-items-center">
											<div className="flex-1">
												<div className="h6 font-monospace mb-3">Dia 3 – Estratégias na Prática</div>
											</div>
										</div>
										<hr className="my-4" />
										<div className="mb-5 text-body text-opacity-50 flex-1">
											<div className="mb-4 font-monospace lh-lg" style={{fontSize: '14px'}}>
												No último dia, você verá exemplos práticos de como usar os setups da Biblioteca para construir um portfólio automatizado e testável, direto na plataforma.<br/><br/>

												🧠 Da teoria aos cliques: como navegar, filtrar, selecionar e colocar para rodar.
											</div>
										</div>
										
									</CardBody>
								</Card>
							</div>
						</div>
					</div>
				</div>
			</div>

			
		</>
	)
}

export default Captacao;